/* @flow */
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { reduxDispatcher } from 'lib/Dispatcher';
import createSagaMiddleware from 'redux-saga';
import combineRemindReducers from './reducer';
import sagas from './sagas';
import { apolloClient } from 'lib/graphql';

// XXX this is all module global state which will prevent SSR

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// mount it on the Store
const store = createStore(
  combineRemindReducers(apolloClient.reducer()),
  composeWithDevTools(
    applyMiddleware(sagaMiddleware, apolloClient.middleware())
  ),
);

reduxDispatcher.setDispatch(store.dispatch);

// $FlowFixMe ¯\_(ツ)_/¯
sagaMiddleware.run(sagas);

export { apolloClient };

export default store;



// WEBPACK FOOTER //
// ./src/reduxStore.js